import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/footer.css";
import { FaFacebookF, FaInstagram } from "react-icons/fa";

import rambLogo from "../assets/logo.png";
import smaertOmegaLogo from "../assets/smart.png";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //Logic to handle smooth scrolling to sections
  const scrollTold = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const goSection = (id) => {
    if (location.pathname === "/") {
      scrollTold(id);
    } else {
      //If not on home page, navigate home with state to trigger scroll
      navigate("/", { state: { targetId: id } });
    }
  };

  return (
    <footer className="footer">

      {/*Top SEECTION */}
      <div className="footer-top">

        {/* Row 1: Logo and About */}
        <div className="footer-brand-row">
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <img src={rambLogo} alt="RAMB" className="footer-logo" />
            <p style={{ margin: 0, color: '#cbd5e1', fontSize: '14px', maxWidth: '400px' }}>
              Reliable Asset Management & Business solutions tailored for your success.
            </p>
          </div>
          <div className="social-icons">
            <a href="https://www.facebook.com/people/RAMB/61571434017921/"><FaFacebookF /></a>
            <a href="https://www.instagram.com/"><FaInstagram /></a>
          </div>
        </div>

        <div className="footer-divider-thin"></div>

        {/* Row 2: Address */}
        <div className="footer-horizontal-list">
          <h4>Office Address</h4>
          <div className="list-content">
            <p><strong>UK:</strong> 167-169 Great Portland St, 5th Floor, London, W1W 5PF</p>
            <span className="dot-divider">•</span>
            <p><strong>Sri Lanka:</strong> No 29, Muneeswaran Road, 40000, Jaffna</p>
            <span className="dot-divider">•</span>
            <p><strong>Email:</strong> info@ramb.lk</p>
            <span className="dot-divider">•</span>
            <p><strong>Phone:</strong> 021 222 4220 / 021 222 6990</p>
          </div>
        </div>

        {/* Row 3: Links */}
        <div className="footer-horizontal-list">
          <h4>Quick Links</h4>
          <div className="list-content">
            <button className="footer-link-btn" onClick={() => navigate("/")}>Home</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn" onClick={() => goSection("about")}>About Us</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn" onClick={() => navigate("/education-support")}>Education Support</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn" onClick={() => navigate("/loans")}>Loans</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn" onClick={() => navigate("/gold-plus")}>Gold Plus</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn" onClick={() => goSection("contact")}>Contact Us</button>
          </div>
        </div>

        {/* Row 4: Info */}
        <div className="footer-horizontal-list">
          <h4>Information</h4>
          <div className="list-content">
            <button className="footer-link-btn" onClick={() => navigate("/terms")}>Terms & Conditions</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn" onClick={() => navigate("/privacy")}>Privacy Policy</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn" onClick={() => navigate("/topup")}>Cash Top Up</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn" onClick={() => navigate("/gold-price")}>Live Gold Price</button>
            <span className="dot-divider">•</span>
            <button className="footer-link-btn footer-staff-btn" onClick={() => window.open("/staff-portal", "_blank")}>Co-operate Portals</button>
          </div>
        </div>

      </div>
      {/*DIVIDER */}
      <div className="footer-divider"></div>
      {/*BOTTOM */}
      <div className="footer-bottom">

        {/*CENTER */}
        <div className="footer-center">
          <span>Designed by</span>
          <a href="https://www.smartomega.lk/" target="_black" rel="noreferrer">
            <img src={smaertOmegaLogo} alt="Smart Omega Group" />
            Smart Omega Group (PVT) Ltd
          </a>
        </div>

        {/*RIGHT */}
        <div className="footer-right">
          © 2026 RAMB (PVT) Ltd
        </div>

      </div>
    </footer>
  );
};

export default Footer;
